"use client";

import Image from "next/image";
import Link from "next/link";
import { useTranslations } from "next-intl";

export function Footer() {
  const t = useTranslations("HomePage.Footer");

  return (
    <footer className="border-t border-border bg-card/60 backdrop-blur-md px-6 py-12 md:px-12">
      <div className="mx-auto max-w-6xl">
        <div className="grid gap-8 md:grid-cols-4">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <Link href="/" className="mb-4 flex items-center gap-2.5 group">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl overflow-hidden shadow-sm group-hover:scale-105 transition-transform">
                <Image
                  src="/career-loop-logo.png"
                  alt={t("brandAlt")}
                  width={40}
                  height={40}
                  className="h-full w-full object-cover"
                />
              </div>
              <span className="text-xl font-extrabold tracking-tight text-foreground">
                {t("brand")}
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-muted-foreground max-w-sm">
              {t("tagline")}
            </p>
            <div className="mt-4 text-xs text-muted-foreground font-medium">
              Daily Subscription Service · 2 ETB/day (First 3 days free) · Shortcode 8526
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="mb-4 text-sm font-bold tracking-wide text-foreground uppercase">
              {t("columns.company")}
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link href="/" className="text-muted-foreground hover:text-[#FF6B3D] transition-colors">
                  {t("links.company.about")}
                </Link>
              </li>
              <li>
                <Link href="/faq" className="text-muted-foreground hover:text-[#FF6B3D] transition-colors">
                  {t("links.legal.faq")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="mb-4 text-sm font-bold tracking-wide text-foreground uppercase">
              {t("columns.legal")}
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link href="/tos" className="text-muted-foreground hover:text-[#FF6B3D] transition-colors">
                  {t("links.legal.privacy")}
                </Link>
              </li>
              <li>
                <Link href="/tos" className="text-muted-foreground hover:text-[#FF6B3D] transition-colors">
                  {t("links.legal.terms")}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Copyright */}
        <div className="mt-12 border-t border-border/60 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-muted-foreground">
          <p>{t("copyright", { year: new Date().getFullYear() })}</p>
          <p>Customer Support: 0996330808</p>
        </div>
      </div>
    </footer>
  );
}
